import { IoWarningOutline } from "react-icons/io5";

const BANNER_LEVELS = {
  error: "text-red-700 bg-red-100 border-red-400",
  info: "text-blue-700 bg-blue-100 border-blue-400",
  success: "text-green-700 bg-green-100 border-green-400",
  warning: "text-amber-700 bg-amber-100 border-amber-400",
};

function AnnouncementBanner({ title, messages, level = "warning" }) {
  const levelClasses = BANNER_LEVELS[level] || BANNER_LEVELS.warning;

  return (
    <section className="p-4" aria-live="polite">
      <div className={`relative flex flex-col gap-2 rounded-lg border px-4 py-3 ${levelClasses}`} role="alert">
        <div className="flex items-start gap-2">
          <IoWarningOutline className="mt-0.5 h-5 w-5 flex-shrink-0" />
          <div className="min-w-0">
            <strong className="font-bold">{title}</strong>
            <div className="mt-1 space-y-1">
              {messages.map(message => (
                <p key={message} className="block sm:inline">
                  {message}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AnnouncementBanner;
